export default "__VITE_ASSET__4bb5ba03__"